import { replaceSpecialChars } from 'cpool-utils';
import { z } from 'zod';

export const schemaConsorsFirstLastName = z
    .string()
    .min(2)
    .transform((value) => value.replace(/\s{2,}/g, ' '))
    .transform((value) => value.replace(/ ?- ?/g, '-'))
    .transform((value) => value.slice(0, 27))
    .transform(replaceSpecialChars)
    .refine((value) => /^[A-Za-zÖÄÜäöüß]+([ -][A-Za-zÖÄÜäöüß]+)*$/u.test(value), {
        message: 'Invalid characters',
    });
